import { EnumEndpoints } from "@/constants/app/type"
import baseAxios from "../../../../services/baseAxios"
import dayjs from "dayjs"
import { parseJson } from "@/utils/safeParse/parseJson"
import { EnumAPIKey } from "@/constants/app/api"

export const getFareRuleService = async ({ flightType, lang }: any) => {
  const cachedFareRule = localStorage.getItem(`fareRule${lang}${flightType}`)
  const now = dayjs()
  let cacheTime = dayjs(parseFloat(localStorage.getItem(`fareRuleCachedTime${lang}${flightType}`) || '0'))
  
  const isExpired = cacheTime.diff(now, 'minute') <= 60
  
  if (!!cachedFareRule && !isExpired) {
    return parseJson(cachedFareRule) || []
  }

  let res = await baseAxios(EnumAPIKey.API_BASE).post(EnumEndpoints.GET_FARE_RULES_0, {
    flightType,
    lang
  }, {
    headers: {
      'Content-Type': 'application/json'
    }
  })

  localStorage.setItem(`fareRuleCachedTime${lang}${flightType}`, `${now.add(12, 'hour').valueOf()}`)

  if (Array.isArray(res)) {
    localStorage.setItem(`fareRule${lang}${flightType}`, JSON.stringify(res))
  }
  return res
}